import fesRequest from './fesRequest'

/**
 * Get HeadlessCms content
 *
 * @param {string} versionNumber version e.g. v1
 * @param {string} brandName Brand
 * @param {string} languageId pl
 * @returns returns AEM HeadlessCms content
 */
export function getCmsContent(versionNumber, brandName, languageId) {
  return new Promise((resolve, reject) => {
    fesRequest({
      method: 'GET',
      path: '/content-integration',
      secondaryPath: `/${versionNumber}/${brandName}/${languageId}`,
      applyProductPath: false,
    })
      .then(result => {
        resolve(result)
      })
      .catch(error => reject(error))
  })
}
